module.exports = __webpack_public_path__ + "img/shipo-icon-checkbox-true.a0b5ce8e.svg";